import { api, plainAxios } from "./http";
import { getAccessTokenOrRefresh } from "@/lib/tokenFactory";
import { asJson, asMultipart } from "./headers";
import { currentLinkTransactionConfig } from "@/lib/linkTransaction";

export const getMe = async (accessToken = null) => {
  const headers = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else {
    const token = await getAccessTokenOrRefresh();
    headers.Authorization = `Bearer ${token}`;
  }
  return plainAxios.get("/connect/me", { headers });
};

export const getMyOrganizations = async (accessToken = null, params = null) => {
  const headers = {};
  if (accessToken) {
    headers.Authorization = `Bearer ${accessToken}`;
  } else {
    const token = await getAccessTokenOrRefresh();
    headers.Authorization = `Bearer ${token}`;
  }
  return plainAxios.get("/organizations/my", { headers, params });
};

export const leaveMyOrganization = async (organizationId) => {
  return api.post(`/account/organizations/${organizationId}/leave`, null, asJson());
};

export const requestPermission = async (payload) => {
  return api.post("/account/requestPermission", payload, asJson());
};

export const changePassword = async (values) => {
  return api.post("/account/changePassword", values, asJson());
};

export const requestEmailChange = async (values) => {
  return api.post("/account/changeEmail", values, asJson());
};

export const confirmEmailChange = () =>
  plainAxios.post(
    "/account/confirmEmailChange",
    null,
    currentLinkTransactionConfig(),
  );

export const requestResetPassword = async (email) => {
  const payload = { email };
  return plainAxios.post(
    "/account/requestResetPassword",
    payload,
    currentLinkTransactionConfig(asJson()),
  );
};

export const getEmailActionContext = () =>
  plainAxios.get(
    "/account/email-action",
    currentLinkTransactionConfig(),
  );

export const resetPassword = async (newPassword) => {
  const payload = { newPassword };
  return plainAxios.post(
    "/account/resetPassword",
    payload,
    currentLinkTransactionConfig(asJson()),
  );
};

export const changeUserName = async (values) => {
  const payload = {
    newFirstName: values.firstName,
    newLastName: values.lastName,
  };
  return api.post("/account/changeUserName", payload, asJson());
};

export const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append("file", file);

  return api.post("/account/avatar", formData, asMultipart());
};

export const deleteAvatar = async () => {
  return api.delete("/account/avatar", asMultipart());
};

export const changeCookieSettings = async (values) => {
  return api.post("/account/changeCookieSettings", values, asJson());
};

export const logoutAllSessions = async () => {
  return api.post("/session/logout/all", asJson());
};

export const logoutOtherSessions = async () => {
  return api.post("/session/logout/others", asJson());
};

export const getActiveSessions = async () => {
  return api.get("/session", asJson());
};

export const revokeSession = async (sessionId) => {
  return api.delete(`/session/${sessionId}`, asJson());
};

export const endCurrentImpersonation = async () => {
  return api.post("/session/impersonation/end", null, asJson());
};

export const deleteAccount = async () => {
  return api.delete("/account", asJson());
};

export const confirmAccountDeletion = () =>
  plainAxios.post(
    "/account/confirmAccountDeletion",
    null,
    currentLinkTransactionConfig(),
  );

export const resendAccountDeletion = async () => {
  return plainAxios.post(
    "/account/deletion/resend",
    null,
    currentLinkTransactionConfig(asJson()),
  );
};

export const exportData = async () => {
  return api.get("/account/export", asJson());
};

export const setLanguage = async (languageCode) => {
  return api.post("/translation/me", { languageCode }, asJson());
};

export const getBuildVersion = async () => {
  return api.get("/__version", asJson());
};

export const getMyImpersonationPin = async () => {
  return api.get("/account/impersonation/pin", asJson());
};
